module.exports = __webpack_public_path__ + "img/bkartel_header.c8c137e3.png";